// extracted by mini-css-extract-plugin
export default {"errorText":"style__errorText___jRozW"};